import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  where,
} from "firebase/firestore";
import { useAuth } from "../context/AuthContext";

export default function useRealtimeBookings() {
  const { user, isAdmin } = useAuth();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Not logged in
    if (!user) {
      setBookings([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    const bookingsRef = collection(db, "bookings");

    const q = isAdmin
      ? query(bookingsRef, orderBy("createdAt", "desc"))
      : query(
          bookingsRef,
          where("userId", "==", user.uid),
          orderBy("createdAt", "desc")
        );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const items = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          createdAt:
            doc.data().createdAt?.toDate?.() ?? doc.data().createdAt,
        }));
        setBookings(items);
        setLoading(false);
      },
      (err) => {
        console.error("🔥 Firestore error:", err.code);
        setError(
          new Error("You don’t have permission to view these bookings.")
        );
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [user, isAdmin]);

  return {
    bookings,
    loading,
    error,
  };
}
